<template lang="pug">
  div(
    style={
      position: 'relative',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      margin: 'auto',
      width: '700px',
      height: '200px',
      'text-align': 'center',
    }
  )
    .content
      h1 CPE Scholar
    form(onsubmit="event.preventDefault()")
      b-field
        b-input(
          placeholder="Username" v-model="username"
        )
      b-field()
        b-input(
          placeholder="password" v-model="password"
          type='password'
          
        )
      .content
        p(v-if='loginFailed' class='has-text-danger') Username or password is not correct
      b-button(type='is-primary' icon-left='sign-in-alt'
        @click="()=>{loginUI()}" :loading='isLoggingIn') Log in
</template>
<script>
import {mapActions, mapState} from 'vuex'
export default{
  data:()=>({
    username:"awakened",
    password:"1234",
    loginFailed:null
  }),
  computed:{
    ...mapState('authentication',{
      isLoggingIn:s=>s.isLoggingIn
    })
  },
  methods:{
    ...mapActions('authentication', ['login']),
    async loginUI(){
      const loginResult = await this.login({username:this.username, password:this.password})
      if(loginResult === 'success'){
       this.navigate('/searchPaper') 
      }else if(loginResult === 'wrong_userpass'){
        this.loginFailed = true
      }else if(loginResult === 'connection_error'){
        this.openErrorMessageBox('There is an error logging in. Please try again later.')
      }
    }

  }
}
</script>